module.exports = __webpack_public_path__ + "static/media/logo_beplay_branco.a20c3fda.webp";